export default "__VITE_ASSET__qprc59zH__"